import { createRoot } from "react-dom/client";
import injectSheet, { ThemeProvider } from "react-jss";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import { store, persistor } from "./store";
import { Colors } from "./config";
import App from "./App";
import { getTheme } from "../lib/player/src/Customisation";

const styles = theme => ({
  "@global body": {
    margin: 0,
    padding: 0,
    "font-family": theme.fontFamily,
    "font-size": theme.fontSize,
  },
  "@global [contenteditable]": {
    "-webkit-user-select": "text",
    "user-select": "text",
  },
  "@font-face": [
    {
      "font-family": "DaytonaPro-Regular",
      src: "url(/assets/fonts/DaytonaPro-Regular.ttf)",
    },
    {
      "font-family": "DaytonaPro-Light",
      src: "url(/assets/fonts/DaytonaPro-Light.ttf)",
    },
    {
      "font-family": "DaytonaPro-Thin",
      src: "url(/assets/fonts/DaytonaPro-Thin.ttf)",
    },
  ],
});

const theme = {
  colorRed: Colors.Red,
  colorPrimary: Colors.Blue,
  colorSecondary: Colors.Orange,
  colorAlternative: Colors.Green,
  colorBackground: Colors.Black,
  colorBlack: Colors.VantaBlack,
  colorDarkGrey: Colors.DarkGrey,
  colorGrey: Colors.Grey,
  colorLightGrey: Colors.LightGrey,
  colorError: Colors.Orange,
  textColor: Colors.White,

  fontFamily: "DaytonaPro-Light",
  fontSize: "14px",
  fontWeight: "900",

  iconSize: "18px",
  borderRadius: "3px",
  borderRadius2: "14px",
  transitionDuration: "0.25s",
  spacing1: "4px",
  spacing2: "8px",
  spacing3: "16px",
  spacing4: "32px",

  ...getTheme(),
};

const StyledApp = injectSheet(styles)(App);

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ThemeProvider theme={theme}>
        <StyledApp />
      </ThemeProvider>
    </PersistGate>
  </Provider>,
);
